import swal from "sweetalert"

export const onSuccess = (
  message = `Ваша заявка прийнята. Чекайте на дзвінок!`
) => {
  swal("Вітаємо!", message, "success")
}
export const onFail = () => {
  swal("Помилка!", `Сервіс не відповідає спробуйте пізніше`, "error")
}

export const onRule = () => {
  swal(
    "Увага!",
    `Для відправки заяки потрібно  дати згоду на обробку та використання своїх персональних даних`,
    "info"
  )
}
